import React, { useEffect } from 'react';
import { useAnalytics } from '../analytics';
import { useLocalUser } from '../hooks/use-local-user';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const AnalyticsUserIdMonitor = () => {
  const analytics = useAnalytics();
  const user = useLocalUser();
  const userId = (user === null || user === void 0 ? void 0 : user.scentregroupId) || null;
  useEffect(() => {
    analytics.setUserId(userId);
  }, [analytics, userId]);
  return /*#__PURE__*/_jsx(_Fragment, {});
};